import { useState } from "react";

// A side-panel section that starts folded to its title, so reference data
// (bookings, passengers, raw records) does not push the work off screen.
export default function FoldSection({ title, children, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="border rounded-2xl overflow-hidden bg-white">
      <button
        type="button"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        className="w-full bg-gray-50 px-4 py-3 text-sm font-semibold flex items-center justify-between text-left hover:bg-gray-100"
      >
        <span>{title}</span>
        <span className="text-xs font-normal text-gray-500">{open ? "Hide ▴" : "Show ▾"}</span>
      </button>
      {open ? <div className="[&>div]:border-0 [&>div]:rounded-none">{children}</div> : null}
    </div>
  );
}
